import Modal from "../../components/Modal/Modal";
import React, { useCallback, useMemo } from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";

const ContentWaper = styled.div`
  max-height: 80vh;
`;
export const ModalPolicy = ({ value, ...props }) => {
  const { T, language } = useApp();

  const onClose = () => {
    props.onClose();
  };
  const { handleSubmit } = { value, ...props };

  const renderPolicyContent = useCallback(() => {
    if (language === "ja") {
      return (
        <div className="text-[#000000] leading-[26px] md:pl-[5px] xs:pl-[5px] lg:pr-[20px] md:pr-[10px] xs:pr-[10px]">
          <div className="mb-[20px]">
            <div className="font-bold text-[18px] text-left">第1条（目的）</div>
            <p className="text-[16px] mb-[20px] text-left">
              本規約は、[AI AVATAR Pte.
              Ltd.]（以下、「当社」という）が提供するAffiliateプログラム（以下、「本プログラム」という）に関する条件を定め、当社とAffiliate参加者（以下、「Affiliate」という）との間の権利義務関係を明確にすることを目的とします。
            </p>
          </div>
          <div className="mb-[20px]">
            <div className="font-bold text-[18px]">第2条（定義）</div>
            <div className="text-[16px] mb-[20px]">
              <ul className="list-decimal pl-10">
                <li>
                  <div>「Affiliate」</div>
                  <div className="pl-10">
                    本規約に同意し、本プログラムに参加する個人または法人を指します。
                  </div>
                </li>
                <li>
                  <div>「Affiliateリンク」</div>
                  <div className="pl-10">
                    Affiliateが自身のウェブサイト、ブログ、SNS等に掲載する、当社または広告主のウェブサイトへ誘導するリンクを指します。
                  </div>
                </li>
                <li>
                  <div>コミッション</div>
                  <div className="pl-10">
                    コミッション支払ルールに基づき、当社からAffiliateに支払われる報酬を指します。
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="font-bold text-[18px]">第3条（参加資格）</div>
          <p className="text-[16px] mb-[20px]">
            本プログラムに参加するには、何らの資格及び負担も必要ありません。ただし、18歳未満の方及び高校生の方は参加できません。
          </p>
          <div className="font-bold text-[18px]">第4条（報酬および支払い）</div>
          <div className="text-[16px]">
            <p className="mb-[12px]">
              本プログラムの報酬の支払いは、当社が指定する方法および期間に従って行われます。
            </p>
            <p className="mb-[20px]">
              不正な手段により発生した報酬は支払われません。
            </p>
          </div>
          <div className="font-bold text-[18px]">
            第5条（SNSアカウントの情報提供）
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="text-[16px] mb-[20px]">
              全Affiliateは、当社に対して本プログラムの宣伝に使用するSNSアカウントのアカウント名等の情報を、当社の求めに応じて提供します。
            </p>
          </div>
          <div className="font-bold text-[18px]">
            第6条（コンプライアンス遵守）
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              全Affiliateは、法令や社会規範を遵守し、誠実に活動を行うことを誓います。
            </p>
          </div>

          <div className="font-bold text-[18px]">第7条（資料提供）</div>
          <div className="text-[16px] mb-[20px]">
            <ul className="list-decimal pl-10">
              <li>
                <div>
                  全Affiliateは、当社が提供する資料のみを利用して宣伝活動を行います。
                </div>
              </li>
              <li>
                <div>
                  第1項における資料について希望するAffiliateは、当社に対して申請を行い、当社から資料の提供を行います。
                </div>
              </li>
              <li>
                <div>
                  提供を受けた資料については、pdf化その他の方法により無断で共有をすることを禁止します。
                </div>
              </li>
              <li>
                <div>
                  第1項及び第3項に違反したことが発覚した場合、当社からの厳重注意やアカウントの停止措置を行う可能性があります。
                </div>
              </li>
            </ul>
          </div>

          <div className="font-bold text-[18px]">第8条（禁止事項）</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[8px]">
              Affiliateは以下の行為を行ってはなりません。
            </p>
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>データおよび資料の無断修正及び改ざん</div>
              </li>
              <li>
                <div>AI AVATARでの複数ポジションのビジネス活動</div>
              </li>
              <li>
                <div>
                  私的なグッズによる勧誘の禁止（会社が支給する全てのグッズを利用可能とする。）
                </div>
              </li>
              <li>
                <div>不適切な手段・文言を用いて宣伝を行うこと</div>
              </li>
              <li>
                <div>
                  当社の社員でないにもかかわらず、第三者に対し当社の社員であると名乗ること
                </div>
              </li>
              <li>
                <div>AI AVATAR以外のセミナー参加及び勧誘</div>
              </li>
              <li>
                <div>
                  報酬を得るために自ら購入すること。なお自らの購入には、本人名義ではなく友人知人、家族名義も含まれます
                </div>
              </li>
              <li>
                <div>
                  会社に批判的な言動など、他のアフィリエイターの活動意欲を減退させる行為
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              上記に違反した場合、当社から厳重注意を行う場合があります。
            </p>
          </div>

          <div className="font-bold text-[18px]">第9条（登録の解除）</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              当社は、Affiliateが以下の事項のいずれかに違反した場合、事前の通知なくAffiliate登録を解除することができます。
            </p>
            <p className="mb-[12px]">
              （1）第7条各号に掲げる事項に関し、当社から厳重注意を受けたとき。ただし、第7条4号に違反したことが発覚した場合は、厳重注意を行うことなく解除することがあります
            </p>
            <p className="mb-[12px]">
              （2）違法な手段・文言を用いて販売を行ったことが判明したとき
            </p>
            <p className="mb-[12px]">
              （3）Affiliateが法令違反をしたことが判明したとき
            </p>
            <p className="mb-[12px]">
              （4）Affiliateが2ヶ月連続で活動が確認できない又は今後活動が継続できないことが明らかである時
            </p>
            <p className="mb-[12px]">
              （5）Affiliateが18歳未満または高校生であることが判明したとき
            </p>
            <p className="mb-[12px]">
              登録解除後、Affiliateは未払いの報酬を請求することはできません。
            </p>
          </div>
          <div className="font-bold text-[18px]">第10条（免責事項）</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[12px]">
              当社は、本プログラムの運営に関し、Affiliateに生じた損害について一切の責任を負いません。
            </p>
            <p className="mb-[12px]">
              当社は、システム障害や第三者による不正行為等により発生した損害についても、一切の責任を負いません。
            </p>
          </div>
          <div className="font-bold text-[18px]">
            第11条（個人情報の取扱い）
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              当社は、個人情報を適切に管理し、当社のプライバシーポリシーに基づき取り扱います。
            </p>
          </div>
          <div className="font-bold text-[18px]">第12条（約款の変更）</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[4px]">
              当社は、必要と判断した場合、本規約を変更することができます。変更後の約款は、当社のウェブサイトに掲載した時点で効力を生じるものとします。
            </p>
          </div>
          <div className="font-bold text-[18px]">
            第13条（準拠法および裁判管轄）
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[4px]">
              本規約の解釈および適用は、日本法に準拠するものとします。
            </p>
            <p className="mb-[4px]">
              本プログラムに関する紛争が生じた場合、本社所在地（シンガポール）を管轄する裁判所を専属的合意管轄とします。
            </p>
          </div>
          <div className="font-bold text-[18px]">第14条（機密保持）</div>
          <div className="text-[16px] mb-[20px]">
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  Affiliateは、本プログラムに関連して知り得た当社または他のAffiliateの技術情報、営業情報、業務情報、顧客情報その他の機密情報（以下、「機密情報」という）を、当社の事前の書面による承諾を得ずに第三者に開示、漏洩してはならず、また自己の業務目的以外に使用してはなりません。
                </div>
              </li>
              <li>
                <div>
                  以下に該当する情報は、機密情報には該当しないものとします。
                  <ul className="list-disc pl-10 mb-[12px]">
                    <li>既に公知であった情報</li>
                    <li>Affiliateが受領する前に公知であった情報</li>
                    <li>Affiliateが正当な権限に基づき第三者から取得した情報</li>
                  </ul>
                </div>
              </li>
              <li>
                <div>
                  Affiliateは、機密情報を適切に管理し、当該情報の漏洩、紛失、不正使用がないよう必要な措置を講じるものとします。
                </div>
              </li>
              <li>
                <div>
                  本条の規定は、Affiliateが本プログラムを終了した後も有効に存続します。
                </div>
              </li>
            </ul>
          </div>
        </div>
      );
    } else if (language === "pt") {
      return (
        <div className="text-[#000000] leading-[26px] md:pl-[5px] xs:pl-[5px] lg:pr-[20px] md:pr-[10px] xs:pr-[10px] pt-[10px]">
          <div className="mb-[20px]">
            <div className="font-bold text-[18px] text-left">
              Artigo 1 (Objetivo)
            </div>
            <p className="text-[16px] mb-[20px] text-left">
              Estes Termos e Condições (“Termos”) definem as condições do
              Programa de Afiliados (“Programa”) fornecido pela [AI AVATAR Pte.
              Ltd.] (“Empresa”) e esclarecem os direitos e obrigações entre a
              Empresa e os participantes do Programa (“Afiliados”).
            </p>
          </div>
          <div className="mb-[20px]">
            <div className="font-bold text-[18px]">Artigo 2 (Definições)</div>
            <p className="text-[16px] mb-[20px]">
              <ul className="list-decimal pl-10">
                <li>
                  <div>"Afiliado"</div>
                  <div>
                    Refere-se a uma pessoa física ou jurídica que concorda com
                    estes Termos e participa do Programa.
                  </div>
                </li>
                <li>
                  <div>"Link de Afiliado"</div>
                  <div>
                    Refere-se a um link publicado pelo Afiliado em seu site,
                    blog, rede social, etc., que direciona os usuários para o
                    site da Empresa ou de um anunciante.
                  </div>
                </li>
                <li>
                  <div>"Comissão"</div>
                  <div>
                    Refere-se à recompensa paga pela Empresa ao Afiliado de
                    acordo com as regras de pagamento de comissão.
                  </div>
                </li>
              </ul>
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 3 (Elegibilidade para Participação)
          </div>
          <p className="text-[16px] mb-[20px]">
            Não são exigidas qualificações ou obrigações específicas para
            participar deste programa. No entanto, menores de 18 anos e
            estudantes do ensino médio não são elegíveis para participar.
          </p>
          <div className="font-bold text-[18px]">
            Artigo 4 (Recompensas e Pagamentos)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              As recompensas deste Programa serão pagas de acordo com o método e
              o período designados pela Empresa.
            </p>
            <p>Recompensas obtidas por meios fraudulentos não serão pagas.</p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 5 (Fornecimento de Informações da Conta SRS)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="text-[16px] mb-[20px]">
              Todos os Afiliados deverão fornecer informações, como o nome da
              conta da SRS utilizada para promoção do Programa, mediante
              solicitação da Empresa.
            </p>
          </div>
          <div className="font-bold text-[18px]">Artigo 6 (Conformidade)</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              Todos os Afiliados deverão cumprir as leis e normas sociais e
              conduzir atividades com integridade.
            </p>
          </div>

          <div className="font-bold text-[18px]">
            Artigo 7 (Fornecimento de Informações)
          </div>
          <div className="text-[16px]">
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  Todos os Afiliados deverão conduzir atividades promocionais
                  utilizando apenas os materiais fornecidos pela Empresa.
                </div>
              </li>
              <li>
                <div>
                  Os Afiliados que desejarem receber tais materiais deverão se
                  inscrever junto à Empresa, e a Empresa os fornecerá de acordo.
                </div>
              </li>
              <li>
                <div>
                  Os materiais fornecidos não devem ser compartilhados sem
                  autorização, inclusive via PDF ou outros meios.
                </div>
              </li>
              <li>
                <div>
                  4. Caso seja constatado que um Afiliado violou o parágrafo 1
                  ou 3, a Empresa poderá emitir uma advertência severa ou
                  suspender a conta.
                </div>
              </li>
            </ul>
          </div>

          <div className="font-bold text-[18px]">Artigo 8 (Atos Proibidos)</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Os Afiliados não devem se envolver nas seguintes atividades:
            </p>
            <ul className="list-disc pl-10 mb-[12px]">
              <li>
                <div>
                  Modificação ou falsificação não autorizada de dados ou
                  materiais
                </div>
              </li>
              <li>
                <div>
                  Atividades comerciais que envolvam múltiplas posições no AI
                  AVATAR
                </div>
              </li>
              <li>
                <div>
                  É proibida a solicitação utilizando bens pessoais (todos os
                  bens fornecidos pela empresa podem ser utilizados)
                </div>
              </li>
              <li>
                <div>Promoção por meio de meios ou linguagem impróprios</div>
              </li>
              <li>
                <div>Alegar ser funcionário da Empresa quando não for</div>
              </li>
              <li>
                <div>
                  Participação ou solicitação de seminários não relacionados ao
                  AI AVATAR
                </div>
              </li>
              <li>
                <div>
                  Compra de produtos com o objetivo de ganhar recompensas,
                  incluindo compras feitas em nome de amigos, conhecidos ou
                  familiares em vez do próprio
                </div>
              </li>
              <li>
                <div>
                  Qualquer conduta que critique a Empresa ou desencoraje as
                  atividades de outros Afiliados
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              A violação do acima exposto poderá resultar em advertências
              severas ou suspensão da conta do Afiliado.
            </p>
          </div>

          <div className="font-bold text-[18px]">
            Artigo 9 (Encerramento do Registro)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              A Empresa poderá encerrar o registro de um Afiliado sem aviso
              prévio nos seguintes casos:
            </p>
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  Se o Afiliado receber uma advertência severa da Empresa sobre
                  os assuntos listados no Artigo 7. No entanto, se uma violação
                  do Artigo 7.4 for descoberta, a Empresa poderá encerrar o
                  registro sem aviso prévio.
                </div>
              </li>
              <li>
                <div>
                  Se ficar claro que o Afiliado realizou vendas usando métodos
                  ou linguagem ilegais
                </div>
              </li>
              <li>
                <div>
                  Se ficar evidente que o Afiliado violou leis ou regulamentos
                </div>
              </li>
              <li>
                <div>
                  Se o Afiliado estiver inativo por dois meses consecutivos ou
                  claramente impossibilitado de continuar as atividades
                </div>
              </li>
              <li>
                <div>
                  Quando for constatado que o Afiliado é menor de 18 anos ou é
                  estudante do ensino médio
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              Após o cancelamento do cadastro, o Afiliado não poderá reivindicar
              comissões não pagas.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 10 (Isenção de Responsabilidade)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              A Empresa não será responsável por quaisquer danos incorridos pelo
              Afiliado em conexão com a operação do Programa.
            </p>
            <p className="mb-[20px]">
              A Empresa também não será responsável por danos causados ​​por
              falhas do sistema ou atos fraudulentos de terceiros.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 11 (Tratamento de Informações Pessoais)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              A Empresa gerenciará adequadamente as informações pessoais e as
              tratará de conformidade com sua Política de Privacidade.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 12 (Alteração dos Termos)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              A Empresa poderá alterar estes Termos a seu critério. Os Termos
              revisados ​​entrarão em vigor após sua publicação no website da
              Empresa.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 13 (Lei Aplicável e Jurisdição)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Estes Termos serão regidos e interpretados de acordo com as leis
              do Japão.
            </p>
            <p>
              Em caso de qualquer litígio decorrente ou relacionado ao Programa,
              os tribunais localizados na sede da Empresa (Singapura) terão
              jurisdição exclusiva.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artigo 14 (Confidencialidade)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Os Afiliados não devem divulgar ou vazar para terceiros, ou usar
              para qualquer finalidade que não seja para negócios com a Empresa,
              quaisquer informações técnicas, comerciais, operacionais, de
              clientes ou outras informações confidenciais ("Informações
              Confidenciais") obtidas por meio do Programa sem o consentimento
              prévio por escrito da Empresa.
            </p>
            <p className="mb-[5px]">
              As seguintes informações não serão consideradas Informações
              Confidenciais:
            </p>
            <ul className="list-disc pl-10 mb-[12px]">
              <li>
                <div>Informações já de conhecimento público</div>
              </li>
              <li>
                <div>Informações conhecidas antes do recebimento</div>
              </li>
              <li>
                <div>
                  Informações obtidas legalmente de terceiros com a devida
                  autorização
                </div>
              </li>
            </ul>
            <p className="mb-[5px]">
              Os Afiliados devem gerenciar as Informações Confidenciais de forma
              adequada e tomar as medidas necessárias para evitar vazamento,
              perda ou uso indevido.
            </p>
            <p className="mb-[5px]">
              Este Artigo permanecerá em vigor mesmo após o término da
              participação do Afiliado no Programa.
            </p>
          </div>
        </div>
      );
    } else if (language === "es") {
      return (
        <div className="text-[#000000] leading-[26px] md:pl-[5px] xs:pl-[5px] lg:pr-[20px] md:pr-[10px] xs:pr-[10px] pt-[10px]">
          <div className="mb-[20px]">
            <div className="font-bold text-[18px] text-left">
              Artículo 1 (Objeto)
            </div>
            <p className="text-[16px] mb-[20px] text-left">
              Estos Términos y Condiciones (“Términos”) definen las condiciones
              del Programa de Afiliados (“Programa”) proporcionado por [AI
              AVATAR Pte. Ltd.] (“Empresa”) y aclaran los derechos y
              obligaciones entre la Empresa y los participantes del Programa
              (“Afiliados”).
            </p>
          </div>
          <div className="mb-[20px]">
            <div className="font-bold text-[18px]">
              Artículo 2 (Definiciones)
            </div>
            <p className="text-[16px] mb-[20px]">
              <ul className="list-decimal pl-10">
                <li>
                  <div>"Afiliado"</div>
                  <div>
                    Se refiere a una persona física o jurídica que acepta estos
                    Términos y participa en el Programa.
                  </div>
                </li>
                <li>
                  <div>"Enlace de Afiliado"</div>
                  <div>
                    Se refiere a un enlace publicado por el Afiliado en su sitio
                    web, blog, red social, etc., que dirige a los usuarios al
                    sitio web de la Empresa o de un anunciante.
                  </div>
                </li>
                <li>
                  <div>"Comisión"</div>
                  <div>
                    Se refiere a la recompensa pagada por la Empresa al Afiliado
                    de acuerdo con las normas de pago de comisiones.
                  </div>
                </li>
              </ul>
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 3 (Requisitos de participación)
          </div>
          <p className="text-[16px] mb-[20px]">
            No se requieren requisitos ni obligaciones específicas para
            participar en este programa. Sin embargo, los menores de 18 años y
            los estudiantes de secundaria no pueden participar.
          </p>
          <div className="font-bold text-[18px]">
            Artículo 4 (Recompensas y Pagos)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Las recompensas de este Programa se pagarán según el método y el
              plazo establecidos por la Compañía.
            </p>
            <p>
              No se pagarán las recompensas obtenidas por medios fraudulentos.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 5 (Suministro de Información de la Cuenta de Redes
            Sociales)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="text-[16px] mb-[20px]">
              Todos los Afiliados deberán proporcionar información como el
              nombre de la cuenta de la Red Social utilizada para la promoción
              del Programa, a solicitud de la Compañía.
            </p>
          </div>
          <div className="font-bold text-[18px]">Artículo 6 (Cumplimiento)</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              Todos los Afiliados deberán cumplir con las leyes y normas
              sociales, y realizar actividades con integridad.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 7 (Suministro de Información)
          </div>
          <div className="text-[16px]">
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  Todos los Afiliados realizarán actividades promocionales
                  utilizando únicamente los materiales proporcionados por la
                  Compañía.
                </div>
              </li>
              <li>
                <div>
                  Los Afiliados que deseen recibir dichos materiales deberán
                  solicitarlo a la Compañía, quien se los proporcionará.
                </div>
              </li>
              <li>
                <div>
                  Los materiales proporcionados no deben compartirse sin
                  autorización, ni siquiera en formato PDF ni por otros medios.
                </div>
              </li>
              <li>
                <div>
                  Si se descubre que un Afiliado ha infringido los párrafos 1 o
                  3, la Compañía podrá emitir una advertencia estricta o
                  suspender su cuenta.
                </div>
              </li>
            </ul>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 8 (Actos Prohibidos)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Los Afiliados no podrán participar en lo siguiente:
            </p>
            <ul className="list-disc pl-10 mb-[12px]">
              <li>
                <div>
                  Modificación o falsificación no autorizada de datos o
                  materiales
                </div>
              </li>
              <li>
                <div>
                  Actividades comerciales que involucren múltiples puestos en AI
                  AVATAR
                </div>
              </li>
              <li>
                <div>
                  Se prohíbe la solicitación con bienes personales (se pueden
                  usar todos los bienes proporcionados por la Compañía)
                </div>
              </li>
              <li>
                <div>Promoción con medios o lenguaje inapropiados</div>
              </li>
              <li>
                <div>Afirmar ser empleado de la Compañía cuando no lo es</div>
              </li>
              <li>
                <div>
                  Participar o solicitar seminarios no relacionados con AI
                  AVATAR
                </div>
              </li>
              <li>
                <div>
                  Comprar productos con el fin de obtener recompensas,
                  incluyendo compras realizadas bajo el nombre de amigos,
                  conocidos o familiares en lugar del propio
                </div>
              </li>
              <li>
                <div>
                  Cualquier conducta que critique a la Compañía o desincentive
                  las actividades de otros Afiliados
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              El incumplimiento de lo anterior puede resultar en advertencias
              estrictas o la suspensión de la cuenta del Afiliado.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 9 (Cancelación del Registro)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              La Compañía puede cancelar el registro de un Afiliado sin previo
              aviso en los siguientes casos:
            </p>
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  Si el Afiliado recibe una advertencia estricta de la Compañía
                  sobre los asuntos enumerados en el Artículo 7.
                </div>
              </li>
              <li>
                <div>
                  Si se demuestra que el Afiliado ha realizado ventas utilizando
                  métodos o lenguaje ilegal.
                </div>
              </li>
              <li>
                <div>
                  Si se demuestra que el Afiliado ha infringido leyes o
                  normativas.
                </div>
              </li>
              <li>
                <div>
                  Si el Afiliado permanece inactivo durante dos meses
                  consecutivos o es claramente incapaz de continuar con sus
                  actividades.
                </div>
              </li>
              <li>
                <div>
                  Si se descubre que el Afiliado es menor de 18 años o
                  estudiante de secundaria.
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              Tras la baja, el Afiliado no podrá reclamar comisiones impagadas.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 10 (Descargo de responsabilidad)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              La Compañía no será responsable de los daños que sufra el Afiliado
              en relación con el funcionamiento del Programa.
            </p>
            <p className="mb-[20px]">
              La Compañía tampoco será responsable de los daños causados ​​por
              fallos del sistema o actos fraudulentos de terceros.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 11 (Tratamiento de la información personal)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              La Compañía gestionará adecuadamente la información personal y la
              manejará de conformidad con su Política de privacidad.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 12 (Modificación de los términos)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              La Compañía podrá modificar estos términos a su discreción. Los
              Términos revisados ​​entrarán en vigor al publicarse en el sitio
              web de la Compañía.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 13 (Ley aplicable y jurisdicción)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Estos Términos se regirán e interpretarán de conformidad con las
              leyes de Japón.
            </p>
            <p>
              En caso de cualquier disputa que surja del Programa o esté
              relacionada con él, los tribunales ubicados en la sede de la
              Compañía (Singapur) tendrán jurisdicción exclusiva.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Artículo 14 (Confidencialidad)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Los afiliados no divulgarán ni filtrarán a terceros, ni utilizarán
              para ningún otro fin que no sea el de realizar negocios con la
              Compañía, ninguna información técnica, comercial, operativa, de
              clientes u otra información confidencial («Información
              Confidencial») obtenida a través del Programa sin el
              consentimiento previo por escrito de la Compañía.
            </p>
            <p className="mb-[5px]">
              La siguiente información no se considerará Información
              Confidencial:
            </p>
            <ul className="list-disc pl-10 mb-[12px]">
              <li>Información ya conocida públicamente</li>
              <li>Información conocida antes de su recepción</li>
              <li>
                Información obtenida legalmente de un tercero con la debida
                autorización
              </li>
            </ul>
            <p className="mb-[5px]">
              Los Afiliados deben gestionar la Información Confidencial de forma
              adecuada y tomar las medidas necesarias para evitar su filtración,
              pérdida o uso indebido.
            </p>
            <p className="mb-[5px]">
              Este Artículo permanecerá vigente incluso después de que finalice
              la participación del Afiliado en el Programa.
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <div className="text-[#000000] leading-[26px] md:pl-[5px] xs:pl-[5px] lg:pr-[20px] md:pr-[10px] xs:pr-[10px] pt-[10px]">
          <div className="mb-[20px]">
            <div className="font-bold text-[18px] text-left">
              Article 1 (Purpose)
            </div>
            <p className="text-[16px] mb-[20px] text-left">
              These Terms and Conditions (“Terms”) define the conditions of the
              Affiliate Program (“Program”) provided by [AI AVATAR Pte. Ltd.]
              (“Company”) and clarify the rights and obligations between the
              Company and participants in the Program (“Affiliates”).
            </p>
          </div>
          <div className="mb-[20px]">
            <div className="font-bold text-[18px]">Article 2 (Definitions)</div>
            <p className="text-[16px] mb-[20px]">
              <ul className="list-decimal pl-10">
                <li>
                  <div>"Affiliate"</div>
                  <div>
                    Refers to an individual or legal entity who agrees to these
                    Terms and participates in the Program.
                  </div>
                </li>
                <li>
                  <div>"Affiliate Link"</div>
                  <div>
                    Refers to a link posted by the Affiliate on their website,
                    blog, SNS, etc., which directs users to the website of the
                    Company or an advertiser.
                  </div>
                </li>
                <li>
                  <div>"Commission"</div>
                  <div>
                    Refers to the reward paid by the Company to the Affiliate in
                    accordance with the commission payment rules.
                  </div>
                </li>
              </ul>
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Article 3 (Eligibility for Participation)
          </div>
          <p className="text-[16px] mb-[20px]">
            No specific qualifications or obligations are required to
            participate in this program. However, individuals under the age of
            18 and high school students are not eligible to participate.
          </p>
          <div className="font-bold text-[18px]">
            Article 4 (Rewards and Payments)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Rewards under this Program shall be paid in accordance with the
              method and period designated by the Company.
            </p>
            <p>Rewards obtained through fraudulent means will not be paid.</p>
          </div>
          <div className="font-bold text-[18px]">
            Article 5 (Provision of SNS Account Information)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="text-[16px] mb-[20px]">
              All Affiliates shall provide information such as the account name
              of the SNS used for promotion of the Program, upon the Company’s
              request.
            </p>
          </div>
          <div className="font-bold text-[18px]">Article 6 (Compliance)</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              All Affiliates shall comply with laws and social norms, and
              conduct activities with integrity.
            </p>
          </div>

          <div className="font-bold text-[18px]">
            Article 7 (Information Provision)
          </div>
          <div className="text-[16px]">
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  All Affiliates shall conduct promotional activities using only
                  the materials provided by the Company.
                </div>
              </li>
              <li>
                <div>
                  Affiliates wishing to receive such materials must apply to the
                  Company, and the Company will provide them accordingly.
                </div>
              </li>
              <li>
                <div>
                  Materials provided must not be shared without authorization,
                  including via PDF or other means.
                </div>
              </li>
              <li>
                <div>
                  If an Affiliate is found to have violated paragraph 1 or 3,
                  the Company may issue a strict warning or suspend the account.
                </div>
              </li>
            </ul>
          </div>

          <div className="font-bold text-[18px]">
            Article 8 (Prohibited Acts)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Affiliates shall not engage in the following:
            </p>
            <ul className="list-disc pl-10 mb-[12px]">
              <li>
                <div>
                  Unauthorized modification or falsification of data or
                  materials
                </div>
              </li>
              <li>
                <div>
                  Business activities involving multiple positions in AI AVATAR
                </div>
              </li>
              <li>
                <div>
                  Solicitation using personal goods is prohibited (all
                  company-provided goods may be used)
                </div>
              </li>
              <li>
                <div>Promotion using inappropriate means or language</div>
              </li>
              <li>
                <div>Claiming to be a Company employee when not</div>
              </li>
              <li>
                <div>
                  Participation in or solicitation for seminars unrelated to AI
                  AVATAR
                </div>
              </li>
              <li>
                <div>
                  Purchasing products for the purpose of earning rewards,
                  including purchases made under names of friends,
                  acquaintances, or family members instead of one’s own
                </div>
              </li>
              <li>
                <div>
                  Any conduct that is critical of the Company or discourages
                  other Affiliates’ activities
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              Violation of the above may result in strict warnings or suspension
              of the Affiliate’s account.
            </p>
          </div>

          <div className="font-bold text-[18px]">
            Article 9 (Termination of Registration)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              The Company may terminate an Affiliate’s registration without
              prior notice in the following cases:
            </p>
            <ul className="list-decimal pl-10 mb-[12px]">
              <li>
                <div>
                  If the Affiliate receives a strict warning from the Company
                  regarding matters listed in Article 7. However, if a violation
                  of Article 7.4 is discovered, the Company may terminate
                  without prior warning.
                </div>
              </li>
              <li>
                <div>
                  If it becomes clear that the Affiliate has conducted sales
                  using illegal methods or language
                </div>
              </li>
              <li>
                <div>
                  If it becomes evident that the Affiliate has violated laws or
                  regulations
                </div>
              </li>
              <li>
                <div>
                  If the Affiliate is inactive for two consecutive months or is
                  clearly unable to continue activities
                </div>
              </li>
              <li>
                <div>
                  When it is found that the Affiliate is under the age of 18 or
                  is a high school student
                </div>
              </li>
            </ul>
            <p className="mb-[20px]">
              After deregistration, the Affiliate may not claim any unpaid
              commissions.
            </p>
          </div>
          <div className="font-bold text-[18px]">Article 10 (Disclaimer)</div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              The Company shall not be liable for any damages incurred by the
              Affiliate in connection with the operation of the Program.
            </p>
            <p className="mb-[20px]">
              The Company shall also not be liable for damages caused by system
              failures or fraudulent acts by third parties.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Article 11 (Handling of Personal Information)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              The Company shall appropriately manage personal information and
              handle it in accordance with its Privacy Policy.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Article 12 (Amendment of Terms)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[20px]">
              The Company may amend these Terms at its discretion. The revised
              Terms shall become effective upon being posted on the Company’s
              website.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Article 13 (Governing Law and Jurisdiction)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              These Terms shall be governed by and construed in accordance with
              the laws of Japan.
            </p>
            <p>
              In the event of any dispute arising out of or in connection with
              the Program, the courts located in the Company's headquarters
              (Singapore) shall have exclusive jurisdiction.
            </p>
          </div>
          <div className="font-bold text-[18px]">
            Article 14 (Confidentiality)
          </div>
          <div className="text-[16px] mb-[20px]">
            <p className="mb-[5px]">
              Affiliates shall not disclose or leak to any third party, or use
              for any purpose other than for business with the Company, any
              technical, business, operational, customer, or other confidential
              information (“Confidential Information”) obtained through the
              Program without the Company’s prior written consent.
            </p>
            <p className="mb-[5px]">
              The following information shall not be considered Confidential
              Information:
            </p>
            <ul className="list-disc pl-10 mb-[12px]">
              <li>
                <div>Information already publicly known</div>
              </li>
              <li>
                <div>Information known prior to receipt</div>
              </li>
              <li>
                <div>
                  Information lawfully obtained from a third party with proper
                  authority
                </div>
              </li>
            </ul>
            <p className="mb-[5px]">
              Affiliates must manage Confidential Information appropriately and
              take necessary measures to prevent leakage, loss, or misuse.
            </p>
            <p className="mb-[5px]">
              This Article shall remain in effect even after the Affiliate’s
              participation in the Program has ended.
            </p>
          </div>
        </div>
      );
    }
  }, [language]);

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="850px"
        onClose={onClose}
        className={
          "!py-[30px] !pl-[22px] !pr-[15px] md:!pr-[25px] lg:!pl-[45px]"
        }
      >
        <ContentWaper>
          <div className="text-aia-red text-center font-medium text-[18px] lg:text-[25px] tracking-[-0.96px] pb-[15px]">
            {T("Affiliate Program Terms and Conditions")}
          </div>
          <div className="modal-body content-agreement max-h-[calc(80vh-140px)]">
            {renderPolicyContent()}
          </div>
          <div className="flex flex-row justify-center items-center pt-6 gap-[15px] border-0  ">
            <button
              className="sm:w-[192px] w-[100%] h-[52px] px-5 py-4 bg-[#ffffff] text-[#000000] text-center rounded-[15px]"
              style={{ border: "1px solid #000000" }}
              type="button"
              onClick={onClose}
            >
              {T("Decline")}
            </button>
            <button
              className="sm:w-[192px] w-[100%] h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
              type="button"
              onClick={() => handleSubmit()}
            >
              {T("Accept")}
            </button>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
